module.exports = __webpack_public_path__ + "img/icon9-1.fe5ff3d1.svg";